module.exports = __webpack_public_path__ + "public/images/slider/malafeeva.f9b9f39cbdbad286741cde8dd5a85620.png";